import { render } from "./Site.vue?vue&type=template&id=dc27c3e2&ts=true"
import script from "./Site.vue?vue&type=script&lang=ts"
export * from "./Site.vue?vue&type=script&lang=ts"

import "./Site.vue?vue&type=style&index=0&id=dc27c3e2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__